import React from "react";
import styled from "@emotion/styled";
import { NavLink } from "react-router-dom";
import useSWR from "swr";

const TABS = [
  { to: "/", label: "받은 요청", end: true, approverOnly: true },
  { to: "/sent", label: "보낸 요청" },
  { to: "/new", label: "새 요청" },
];

function BottomTabs() {
  // me 는 AppShell 에서도 호출하므로 SWR 캐시가 공유돼 추가 요청은 발생하지 않음
  const { data: me } = useSWR("/manager/change-request/me");
  // 받은 요청 노출 자격은 서버 me.is_approver 가 단일 출처(점장4↑ 또는 감정관리자).
  // 구버전 API 호환: is_approver 미존재 시 level 4↑ 로 폴백
  const isApprover =
    me?.is_approver !== undefined ? Boolean(me.is_approver) : Number(me?.level || 0) >= 4;

  // me 가 아직 로드 전이면 approverOnly 가드를 일단 무시 (로딩 중 깜빡임 방지)
  const visible = TABS.filter(
    (t) => !t.approverOnly || me === undefined || isApprover
  );

  return (
    <Bar columns={visible.length}>
      {visible.map((t) => (
        <Tab key={t.to} to={t.to} end={t.end}>
          {({ isActive }) => (
            <Inner active={isActive ? 1 : 0}>{t.label}</Inner>
          )}
        </Tab>
      ))}
    </Bar>
  );
}

const Bar = styled.nav`
  position: sticky;
  bottom: 0;
  height: 60px;
  display: grid;
  grid-template-columns: ${({ columns }) => `repeat(${columns}, 1fr)`};
  background: #ffffff;
  border-top: 1px solid #e6e8eb;
  z-index: 10;
`;
const Tab = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
`;
const Inner = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: ${({ active }) => (active ? "#003580" : "#888888")};
  border-top: 2px solid ${({ active }) => (active ? "#003580" : "transparent")};
  padding-top: 6px;
  height: 100%;
  display: flex;
  align-items: center;
`;

export default BottomTabs;
